<template>
  <div>
    <div class="title-div">燃气报修</div>
    <div class="query-div">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="燃气户号">
          <el-input v-model="formInline.gasAccount" placeholder="请输入燃气户号"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="content-div" v-loading="loading">
      <transition name="el-fade-in">
        <div class="warm-div" v-show="warm">
          <div><img src="" alt=""></div>
          <div class="warm-text"><span>如有漏气、爆炸、着火、人员伤亡等紧急燃气事件，请立即拨打</span><span style="color: red;font-weight: bolder">96777</span>
          </div>
          <div class="warm-close"><i class="el-icon-circle-close" style="color: #FFC272" @click="close"></i></div>
        </div>
      </transition>


      <div class="function1-div">
        <div class="component-div" @click="checkUserGas('管道阀门')">
          <div class="img-div"><img src="../../../assets/pc/pcRepair/repair1.png" alt="" width="98"></div>
          <div class="component-text" style="left: 95px"><span>管道阀门</span></div>
          <div class="blank-line"></div>
        </div>

        <div class="component-div" @click="checkUserGas('燃气表')">
          <div class="img-div"><img src="../../../assets/pc/pcRepair/repair2.png" alt="" width="98"></div>
          <div class="component-text"><span>燃气表</span></div>
          <div class="blank-line"></div>
        </div>

        <div class="component-div" @click="checkUserGas('燃气具')">
          <div class="img-div"><img src="../../../assets/pc/pcRepair/repair3.png" alt="" width="98"></div>
          <div class="component-text"><span>燃气具</span></div>
          <div class="blank-line"></div>
        </div>

        <div class="component-div" @click="checkUserGas('燃气拆改')">
          <div class="img-div"><img src="../../../assets/pc/pcRepair/repair4.png" alt="" width="98"></div>
          <div class="component-text" style="left: 95px"><span>燃气拆改</span></div>
          <div class="blank-line"></div>
        </div>

        <div class="component-div" @click="checkUserGas('其他报修')">
          <div class="img-div"><img src="../../../assets/pc/pcRepair/repair5.png" alt="" width="98"></div>
          <div class="component-text" style="left: 95px"><span>其他报修</span></div>
          <div class="blank-line"></div>
        </div>

        <div class="component-div" @click="checkUserGas('我的')">
          <div class="img-div"><img src="../../../assets/pc/pcRepair/repair6.png" alt="" width="98"></div>
          <div class="component-text" style="left: 95px"><span>我的报修</span></div>
          <div class="blank-line"></div>
        </div>

      </div>


    </div>
  </div>

</template>

<script>
  import { getBjtongAccessToken, checkUserGas, operationRecords } from '../../../api/accountInformation'
  import { getToken } from '../../../api/login'

  export default {
    name: 'GasRepair',
    data () {
      return {
        warm: true,
        code: '', // 统一认证平台返回的code
        loading: false, // 加载提示
        telephone: '', // 登录时的用户名
        password: '', // 登录密码
        formInline: {
          gasAccount: '' // 燃气户号-查询条件
        },
        gasAccountInfo: {} // 户号信息
      }
    },
    mounted () {
      this.code = this.$route.query.code
      console.log('统一认证平台返回的code为', this.code)
      this.getBjtongAccessToken(this.code)
    },
    methods: {
      //关闭上方提示
      close () {
        this.warm = false
      },

      // 跳转到报修上报页面
      toPCRepair (val) {
        const that = this
        that.$router.push({
          name: 'PCRepair',
          params: {
            title: val,
            gasAccountInfo: that.gasAccountInfo
          }
        })
      },

      // 跳转到我的报修页面
      toPCMyRepair () {
        this.$router.push({
          name: 'PCMyRepair',
          params: {
            gasAccountInfo: this.gasAccountInfo
          }
        })
      },

      // 获取登录人的信息，根据账号密码获得北燃的token
      getBjtongAccessToken (code) {
        const that = this
        that.loading = true
        const params = {
          grantCode: code,
          operationType: '报修'
        }
        getBjtongAccessToken(params).then(res => {
          if (res.data.success) {
            that.telephone = res.data.rows[0].userName
            that.password = res.data.rows[0].passwordEncrypted
            window.localStorage.userId = res.data.rows[0].id
            window.localStorage.userInfo = JSON.stringify(res.data.rows[0])
            that.toAccountNumberManagement()
          } else {
            that.loading = false
            that.$message.error(res.data.message)
          }
        }).catch(() => {
        })
      },

      // 登录
      toAccountNumberManagement () {
        const that = this
        const params = {
          client_id: 'a8117f61-0643-43ba-a172-bca68f497051',
          client_secret: 'a376a615-1ba6-453f-8e30-f68ae0b1b3f9',
          grant_type: 'password',
          username: that.telephone,
          password: 'Bjtong'
        }
        getToken(params).then(res => {
          that.onLogin(res.data)
        }).catch(() => {
          that.loading = false
          that.$message.error('用户名或密码错误')
        })
      },

      // 获取token成功
      onLogin (resp) {
        const that = this
        window.localStorage.smartHistory = ''
        if (resp.access_token) {
          window.localStorage.tokenType = resp.token_type
          window.localStorage.token = resp.access_token
          that.loading = false
        } else {
          that.loading = false
          that.$message.error('获取token失败')
        }
      },

      // 校验户号并绑定
      checkUserGas (type) {
        const that = this
        if (that.formInline.gasAccount === '') {
          that.$message({
            message: '请输入燃气户号',
            type: 'warning'
          })
          return
        }
        that.loading = true
        const params = {
          userId: window.localStorage.userId,
          gasAccount: that.formInline.gasAccount
        }
        checkUserGas(params).then(res => {
          if (res.data.success) {
            that.loading = false
            that.gasAccountInfo = res.data.rows[0]
            if (type == '我的') {
              that.toPCMyRepair()
            } else {
              that.toPCRepair(type)
            }
            that.operationRecords()
          } else {
            that.loading = false
            that.$message.error(res.data.message)
          }
        }).catch(() => {
        })
      },

      // 记录用户操作类型
      operationRecords () {
        const that = this
        const params = {
          userId: window.localStorage.userId,
          gasAccount: that.formInline.gasAccount,
          operationType: '报修'
        }
        operationRecords(params).then(res => {
          if (res.data.success) {
          } else {
            that.$message.error(res.data.message);
          }
        }).catch(() => {
        })
      }
    },
    created () {

    }
  }
</script>

<style scoped>
  .title-div {
    width: 88.5%;
    height: 158px;
    background: #BD1A2D;
    font-size: 38px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 158px;
    padding-left: 11.5%;
  }

  .warm-div {

    width: 70%;
    height: 58px;
    background-color: #FFFAF4;
    border: 1px solid #FFC272;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .content-div {
    position: relative;
    top: 30px;
    padding-bottom: 100px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .warm-text {
    position: absolute;
    top: 18px;
    left: 20%;
    font-size: 16px;
    font-family: 微软雅黑;
  }

  .warm-close {
    position: absolute;
    top: 19px;
    left: 80%;
    font-size: 22px;
  }

  .function1-div {
    width: 75%;
    flex-wrap: wrap;
    justify-content: left;
    padding: 50px 15% 10px 15%;
  }

  .component-div {
    display: inline-block;
    height: 330px;
    width: 260px;
    margin-bottom: 20px;
    background: #FFFFFF;
    border-radius: 2px;
    border: 2px solid #DCDFE6;
  }

  .component-div:hover {
    background: rgba(189, 26, 45, 0.08);
    border-top: 3px solid #BD1A2D;
    cursor: pointer;
  }

  .img-div {
    position: relative;
    top: 69px;
    left: 81px;
  }

  .component-text {
    position: relative;
    top: 130px;
    left: 103px;
    font-size: 18px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
  }

  .blank-line {
    position: relative;
    top: 130px;
    left: 116px;
    width: 27px;
    height: 2px;
    background: #333333;
    border-radius: 2px;
  }

  .query-div {
    text-align: center;
    padding-top: 25px;
  }
</style>
